// Convierte la respuesta de notificación del backend
// ({ sent, channels: { email, whatsapp } } o { sent:false, reason }) en un
// mensaje corto para el toast. Se usa tanto en Registrar como en el Panel
// (entrega y reenviar), así el criterio queda en un solo lugar.
export function describeNotifyResult(result, t) {
  if (!result) return "";
  if (result.reason && !result.channels) return result.reason;

  const parts = [];
  const ch = result.channels || {};
  if (ch.email) parts.push(ch.email.sent ? "✉️" : `✉️ ⚠️ ${ch.email.reason || ""}`);
  if (ch.whatsapp) parts.push(ch.whatsapp.sent ? "WhatsApp ✓" : `WhatsApp ⚠️ ${ch.whatsapp.reason || ""}`);

  if (!parts.length) return t("panel.deliveredNoNotify");
  return parts.join("  ·  ");
}
